import { Action } from '@ngrx/store';
import {DeviceMgtDetail} from '../device-mgt.model';

export enum DeviceDetailActionTypes {
  LoadDeviceDetails = '[DeviceDetail] Load DeviceDetails',
  GetDeviceDetails = '[DeviceDetail] Get DeviceDetails',
  GetDeviceDetailsFail = '[DeviceDetail] Get DeviceDetails Fail',
}

export class LoadDeviceDetails implements Action {
  readonly type = DeviceDetailActionTypes.LoadDeviceDetails;
  constructor(public payload: DeviceMgtDetail) {}

}

export class GetDeviceDetails implements Action {
  readonly type = DeviceDetailActionTypes.GetDeviceDetails;
  constructor(public payload: number) {}
}

export class GetDeviceDetailsFail implements Action {
  readonly type = DeviceDetailActionTypes.GetDeviceDetailsFail;
}


export type DeviceDetailActions = LoadDeviceDetails
  | GetDeviceDetails
  | GetDeviceDetailsFail;
